import {
    TableRow,
    TableCell,
    Box,
    IconButton,
    Tooltip
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { NodePod } from '../k8s-analyzer-types';
import { calculatePercentage, formatCPU, formatMemory, getCPUColor, getMemoryColor } from './k8s-analyzer-nodes-list.utils';

export function K8sAnalyzerNodesListTablePodRow({ pod }: { pod: NodePod }) {
    const cpuPercentage = calculatePercentage(pod.metrics.cpu.usage, pod.metrics.cpu.capacity, 'cpu');
    const memPercentage = calculatePercentage(pod.metrics.memory.usage, '2097152Ki', 'memory');

    const handleCopyPodName = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.clipboard.writeText(pod.name);
    };

    return (
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: '#fafafa'
            }}
        >
            <TableCell padding="checkbox" align="center">
                P
            </TableCell>
            <TableCell align="center">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {pod.name}
                    </Box>
                    <Tooltip title="Copy pod name">
                        <IconButton
                            size="small"
                            onClick={handleCopyPodName}
                            sx={{ ml: 1 }}
                        >
                            <ContentCopy fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </TableCell>
            <TableCell align="center" >{pod.status || '-'}</TableCell>
            <TableCell align="center" >{pod.role || '-'}</TableCell>
            <TableCell align="center" >{pod.taints || '-'}</TableCell>
            <TableCell align="center" >{pod.version || '-'}</TableCell>
            <TableCell align="center" >{pod.restarts || '-'}</TableCell>
            <TableCell align="right">{formatCPU(pod.metrics.cpu.usage)}</TableCell>
            <TableCell align="right">{formatMemory(pod.metrics.memory.usage)}</TableCell>
            <TableCell
                align="right"
                sx={{
                    color: getCPUColor(cpuPercentage),
                    fontWeight: cpuPercentage > 70 ? 'bold' : 'normal'
                }}
            >
                {Math.round(cpuPercentage)}
            </TableCell>
            <TableCell
                align="right"
                sx={{
                    color: getMemoryColor(memPercentage),
                    fontWeight: memPercentage > 70 ? 'bold' : 'normal'
                }}
            >
                {Math.round(memPercentage)}
            </TableCell>
            <TableCell align="right">{formatCPU(pod.metrics.cpu.capacity)}</TableCell>
            <TableCell align="right">{formatMemory(pod.metrics.memory.capacity)}</TableCell>
            <TableCell align="right">{pod.age || '-'}</TableCell>
        </TableRow>
    );
} 